export default __webpack_public_path__ + "static/media/calls.2924e841.wav";